<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium">
          <el-form-item label="分类：">
            <el-select v-model="searchForm.CATALOG_ID" clearable filterable>
              <el-option v-for="item in catalogList" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker v-model="searchForm.DATE" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="类型：">
            <el-select v-model="searchForm.GROSS_PROFIT_STATEMENT_TYPE" clearable filterable>
              <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="btn" @click="fliterData">筛选</el-button>
            <el-button type="primary" plain class="btn" @click="$_exportForm">导出</el-button>
            <el-button type="primary" plain class="btn" @click="$_exportDetail">导出月报表明细</el-button>
            <el-button type="primary" plain class="btn" @click="$_exportOldDetail">导出旧表</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" max-height="520" stripe border>
          <!-- <el-table-column label="序号" type="index" width="50px"></el-table-column> -->
          <el-table-column label="类别" prop="TYPE_NAME" min-width="100px"></el-table-column>
          <el-table-column label="收入" prop="INCOME" min-width="100px"></el-table-column>
          <!-- <el-table-column v-for="item in kinds" :key="item.TYPE_ID" :label="item.TYPE_NAME" :prop="String(item.TYPE_ID)"></el-table-column> -->
          <el-table-column label="成本" prop="COST"></el-table-column>
          <el-table-column label="毛利" prop="PROFIT"></el-table-column>
          <el-table-column label="毛利率" prop="GROSS_MARGIN"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog title="导出" center :visible.sync="exportVisible" width="600px">
      <el-form :model="exportForm" ref="editForm">
        <el-form-item label="导出方式：" :label-width="formLabelWidth">
          <el-radio v-model="radio" label="1">明细</el-radio>
          <el-radio v-model="radio" label="2">汇总</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportVisible = false">取 消</el-button>
        <el-button @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="导出月报表明细" center :visible.sync="exportDetailVisible" width="600px">
      <el-form :model="exportDetailForm" ref="exportDetailForm">
        <el-form-item label="选择日期：" label-width="180px">
          <el-date-picker v-model="exportDetailForm.MONTH" type="month" placeholder="选择月份">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="版本：" :label-width="formLabelWidth">
          <el-radio v-model="tableRadio" label="1">新版</el-radio>
          <el-radio v-model="tableRadio" label="2">旧版</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportDetailVisible = false">取 消</el-button>
        <el-button @click="submitExport">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryProfit, summary, detail, exportDetail, exportOldDetail, exportOldMonthDetail,
} from 'api/returnWare';
import { getClassFun } from '@/assets/api/skuManage';

export default {
  data() {
    return {
      searchForm: {
        GROSS_PROFIT_STATEMENT_TYPE: '',
      },
      tableData: [],
      kinds: [],
      customer: [],
      exportVisible: false,
      formLabelWidth: '240px',
      radio: '1',
      exportForm: {},
      exportDetailVisible: false,
      exportDetailForm: {},
      tableRadio: '1',
      catalogList: [],
      typeList: [{
        value: '0',
        label: '全部',
      }, {
        value: '1',
        label: '自配',
      }, {
        value: '2',
        label: '第三方',
      }],
      value: '',
    };
  },
  created() {
    this.$set(this.searchForm, 'DATE', this.$store.state.GROSSPROFIT_ALL.DATE);
    this.$set(this.searchForm, 'CATALOG_ID', this.$store.state.GROSSPROFIT_ALL.CATALOG_ID);
    this.queryData();
    this.queryCatalog();
  },
  methods: {
    // 导出日报表明细
    $_exportDetail() {
      this.exportDetailVisible = true;
    },
    submitExport() {
      const params = {};
      if (this.exportDetailForm.MONTH != null) {
        const first = `${new Date(this.exportDetailForm.MONTH).getFullYear()
        }-${(new Date(this.exportDetailForm.MONTH).getMonth() + 1) < 10 ? (`0${new Date(this.exportDetailForm.MONTH).getMonth() + 1}`) : (new Date(this.exportDetailForm.MONTH).getMonth() + 1)}`;
        params.MONTH = first;
      }
      if (!this.exportDetailForm.MONTH) {
        this.$message.show({ text: '请选择日期', type: 'warning' });
        return false;
      }
      if (Number(this.tableRadio == 1)) {
        exportDetail(params).then((res) => {
          window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
          this.exportDetailVisible = false;
          this.$message.show({ text: '导出成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        exportOldMonthDetail(params).then((res) => {
          window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
          this.exportDetailVisible = false;
          this.$message.show({ text: '导出成功', type: 'success' });
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
    },
    // 导出
    $_exportForm() {
      if (this.searchForm.DATE) {
        this.exportVisible = true;
      } else {
        this.$message.show({ text: '请选择起始日期', type: 'warning' });
      }
    },
    // 导出确认
    submitEdit() {
      if (this.radio == '2') {
        const params = {
        };
        if (this.searchForm.CATALOG_ID) {
          params.CATALOG_ID = this.searchForm.CATALOG_ID;
        }
        if (this.searchForm.DATE != null) {
          [params.START_DAY, params.END_DAY] = this.searchForm.DATE;
        }
        if (this.searchForm.GROSS_PROFIT_STATEMENT_TYPE) {
          params.TYPE = this.searchForm.GROSS_PROFIT_STATEMENT_TYPE;
        }
        summary(params).then((res) => {
          if (res.length == 0) {
            this.$message.show({ text: '暂无数据', type: 'warning' });
            this.exportVisible = false;
          } else {
            window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
            this.exportVisible = false;
            this.$message.show({ text: '导出成功', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
      if (this.radio == '1') {
        const params = {
        };
        if (this.searchForm.CATALOG_ID) {
          params.CATALOG_ID = this.searchForm.CATALOG_ID;
        }
        if (this.searchForm.DATE != null) {
          [params.START_DAY, params.END_DAY] = this.searchForm.DATE;
        }
        if (this.searchForm.GROSS_PROFIT_STATEMENT_TYPE) {
          params.TYPE = this.searchForm.GROSS_PROFIT_STATEMENT_TYPE;
        }
        detail(params).then((res) => {
          if (res.length == 0) {
            this.$message.show({ text: '暂无数据', type: 'warning' });
            this.exportVisible = false;
          } else {
            window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
            this.exportVisible = false;
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
    },
    // 筛选
    fliterData() {
      this.queryData();
    },
    // 获取界面数据
    queryData() {
      this.$store.dispatch('GROSSPROFIT_ALL', { DATE: this.searchForm.DATE, CATALOG_ID: this.searchForm.CATALOG_ID });
      const params = {
      };
      if (this.searchForm.CATALOG_ID) {
        params.CATALOG_ID = this.searchForm.CATALOG_ID;
      }
      if (this.searchForm.DATE != null) {
        [params.START_DAY, params.END_DAY] = this.searchForm.DATE;
      }
      if (this.searchForm.GROSS_PROFIT_STATEMENT_TYPE) {
        params.TYPE = this.searchForm.GROSS_PROFIT_STATEMENT_TYPE;
      }
      queryProfit(params).then((result) => {
        this.tableData = result;
        // this.kinds = result[1].TYPE_LIST
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    $_exportOldDetail() {
      const params = {};
      if (this.searchForm.DATE != null) {
        [params.START_DAY, params.END_DAY] = this.searchForm.DATE;
      }
      if (!this.searchForm.DATE) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      exportOldDetail(params).then((res) => {
        if (res.length == 0) {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        } else {
          window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
          this.$message.show({ text: '导出成功', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryCatalog() {
      getClassFun().then((result) => {
        if (result.length !== 0) {
          this.catalogList = result;
        } else {
          this.catalogList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/tableManage/grossProfit.vue